import store from "@/store";
import axios from "axios";
import {toast} from "../class/Notification";
import router from "@/router";


export default {
    namespaced: true,
    state: {
        walletHistories: {},
        walletHistoriesMeta: {},
    },
    mutations: {
        setWalletHistories(state, histories) {
            state.walletHistories = histories
        },
        setWalletHistoriesMeta: (state, meta) => {
            state.walletHistoriesMeta = meta
        },
    },
    actions: {
        adminChargeWallet({commit, state}, form) {
            axios.post(`wallet/admin/charge/user/${form.user_id}`, form)
                .then((res) => {
                    // update wallet if current user and updated user was equal
                    if (form.user_id == store.getters['User/getProfile'].id) {
                        store.getters['User/getProfile'].wallet = res.data.data
                    }
                    toast('شارژ کیف پول با موفقیت انجام شد', 'شارژ کیف پول با موفقیت انجام شد')
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        userChargeWallet({commit, state}, form) {
            axios.post(`wallet/user/charge/user/${form.user_id}`, form)
                .then((res) => {
                    const url = res.data.data.payment_url
                    window.location.href = url;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        walletHistories({commit, state}, form) {
            axios.get(`wallet/history/user/${form.user_id}?page=${form.page}`, form)
                .then((res) => {
                    const histories = res.data.data
                    commit('setWalletHistories', histories.data)
                    commit('setWalletHistoriesMeta', histories.meta)

                })
                .catch((error) => {
                    console.log(error);
                });
        }
    },
    getters: {
        getHistories: (state) => state.walletHistories,
        getHistoriesMeta: (state) => state.walletHistoriesMeta,
    },
};
